export const OPERATOR_DEALS_LIST = 'operator-deals-list'
export const DEAL_DATA = 'deal-data'
export const OPERATOR_ROUTES_LIST = 'operator-routes-list'
export const ROUTE_SERVICES = 'route-services'
export const CLEAR_DEAL_DATA = 'clear-deal-data'
export const FULL_OPERATOR_ROUTES_LIST = 'full-operator-routes-list'
export const SERVICE_SEATLAYOUT = 'service-seatlayout'
export const THROW_SEATMAP_ERROR = 'throw-seatmap-error'
export const ALL_ROUTES_INFO = 'all-routes-info'
export const AUDIT_DEAL_DATA = 'audit-deal-data'
export const OPERATOR_DEALS_LIST_LOADING = 'operator-deals-list-loading'
export const GET_DEAL_DATA = 'get-deal-data'
export const GET_SERVICE_LIST = 'GET_SERVICE_LIST'
export const GET_SEAT = 'GET_SEAT'
export const GET_BENCH_MARK = 'GET_BENCH_MARK'
export const GET_TOP_ROUTES = 'GET_TOP_ROUTES'
export const GET_AGGREGATE_DATA = 'GET_AGGREGATE_DATA'
export const GET_DEALS_SUMMARY = 'GET_DEALS_SUMMARY'
export const GET_DATE_WISE_AGGREGRATE_DATA='GET_DATE_WISE_AGGREGRATE_DATA'
export const SET_DYNAMIC_SEAT_DATA = 'SET_DYNAMIC_SEAT_DATA'
export const CLEAR_BENCH_MARK = 'CLEAR_BENCH_MARK'
export const ADD_BTN_CLICKED = 'ADD_BTN_CLICKED'
